import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Programs from "@/components/Programs";
import Benefits from "@/components/Benefits";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import { useLanguage } from "@/i18n/LanguageContext";

const Programme = () => {
    const { t } = useLanguage();
    const seo = t.page_meta.seo.programs;

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <div data-testid="programme-page" className="bg-ella-cream min-h-screen">
            <Header />
            <PageMeta title={seo.title} h1={seo.h1} description={seo.description} />
            <main className="pt-32 md:pt-40">
                <div className="ella-container">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-ella-muted hover:text-ella-ink transition-colors"
                        data-testid="programme-back-home"
                    >
                        <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
                        {t.page_meta.back_home}
                    </Link>
                </div>

                <Programs />
                <Benefits />
            </main>
            <Footer />
        </div>
    );
};

export default Programme;
